// import React, { useState, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../services/api";
// import Avatar from "../common/Avatar";
// import Icon from "../common/Icon";
// import { ChevronDown } from "lucide-react";

// const API_ROOT = (
//   process.env.REACT_APP_API_URL || "http://localhost:5000/api"
// ).replace("/api", "");

// const avSrc = (p) =>
//   !p
//     ? "/assets/images/avatar-brother-julian.png"
//     : p.startsWith("/uploads")
//     ? `${API_ROOT}${p}`
//     : p;

// const POST_TYPES = [
//   { value: "default", label: "Default" },
//   { value: "testimony", label: "Testimony" },
// ];

// const ImageUploadBox = ({ label, preview, onFile, onRemove, inputRef }) => {
//   const [dragOver, setDragOver] = useState(false);

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     const file = e.dataTransfer.files?.[0];
//     if (file && file.type.startsWith("image/")) onFile(file);
//   };

//   return (
//     <div className="flex flex-col gap-2 w-full">
//       {label && (
//         <p className="text-[13px] font-semibold text-gray-700 font-body">{label}</p>
//       )}
//       <div
//         onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
//         onDragLeave={() => setDragOver(false)}
//         onDrop={handleDrop}
//         onClick={() => !preview && inputRef.current?.click()}
//         className={`relative border-2 border-dashed rounded-2xl flex flex-col items-center justify-center transition-all cursor-pointer w-full
//           ${dragOver ? "border-primary bg-yellow-50" : "border-gray-300 bg-gray-50 hover:bg-gray-100"}
//           ${preview ? "cursor-default" : "cursor-pointer"}
//           h-[160px] sm:h-[192.61px]`}
//       >
//         {preview ? (
//           <>
//             <img
//               src={preview}
//               alt="preview"
//               className="w-full h-full object-cover rounded-2xl"
//             />
//             <button
//               type="button"
//               onClick={(e) => { e.stopPropagation(); onRemove(); }}
//               className="absolute top-2 right-2 w-7 h-7 sm:w-8 sm:h-8 bg-black/60 rounded-full flex items-center justify-center hover:bg-black/80 transition-colors"
//             >
//               <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
//                 <line x1="18" y1="6" x2="6" y2="18" />
//                 <line x1="6" y1="6" x2="18" y2="18" />
//               </svg>
//             </button>
//           </>
//         ) : (
//           <div className="flex flex-col items-center justify-center gap-2 sm:gap-3 p-4">
//             {/* Gallery Image Icon */}
//             <div className="flex items-center justify-center" style={{ width: "60px", height: "60px" }}>
//               <svg width="60" height="60" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <rect x="12" y="16" width="64" height="56" rx="8" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
//                 <circle cx="30" cy="36" r="6" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
//                 <path d="M12 60 L28 40 L44 56 L56 44 L76 60" stroke="#9CA3AF" strokeWidth="2" strokeLinejoin="round" fill="none"/>
//                 <path d="M58 28 L68 38" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
//                 <circle cx="62" cy="26" r="3" fill="#9CA3AF"/>
//               </svg>
//             </div>
//             {/* Text */}
//             <p className="text-[14px] sm:text-[17.76px] font-semibold text-gray-500 text-center font-body">
//               Drop your image here or{" "}
//               <span className="text-[#1F3A60] font-semibold underline cursor-pointer hover:text-[#2a4a7a] transition-colors">
//                 browse
//               </span>
//             </p>
//           </div>
//         )}
//         <input
//           ref={inputRef}
//           type="file"
//           accept="image/*"
//           className="hidden"
//           onChange={(e) => {
//             const file = e.target.files?.[0];
//             if (file) onFile(file);
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// const CreatePostModal = ({ isOpen, onClose, onPostCreated }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   const [postType, setPostType] = useState("default");
//   const [showTypeMenu, setShowTypeMenu] = useState(false);

//   const [content, setContent] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   // Default mode
//   const [attachment, setAttachment] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const fileRef = useRef();

//   // Testimony mode
//   const [beforeFile, setBeforeFile] = useState(null);
//   const [beforePreview, setBeforePreview] = useState(null);
//   const [afterFile, setAfterFile] = useState(null);
//   const [afterPreview, setAfterPreview] = useState(null);
//   const [beforeContent, setBeforeContent] = useState("");
//   const [afterContent, setAfterContent] = useState("");
//   const beforeRef = useRef();
//   const afterRef = useRef();

//   const handleFileSelect = (file) => {
//     setAttachment(file);
//     setPreview(URL.createObjectURL(file));
//   };

//   const handleBeforeFile = (file) => {
//     setBeforeFile(file);
//     setBeforePreview(URL.createObjectURL(file));
//   };

//   const handleAfterFile = (file) => {
//     setAfterFile(file);
//     setAfterPreview(URL.createObjectURL(file));
//   };

//   const handleTypeSelect = (val) => {
//     setPostType(val);
//     setShowTypeMenu(false);
//   };

//   const handleSubmit = async () => {
//     const isTestimony = postType === "testimony";

//     if (isTestimony) {
//       if (!beforeContent.trim() && !afterContent.trim()) {
//         setError("Write something in Before or After...");
//         return;
//       }
//     } else {
//       if (!content.trim()) {
//         setError("Write something to share...");
//         return;
//       }
//     }

//     setError("");
//     setLoading(true);

//     try {
//       const fd = new FormData();
//       fd.append("type", postType);

//       if (isTestimony) {
//         fd.append("beforeContent", beforeContent.trim());
//         fd.append("afterContent", afterContent.trim());
//         if (beforeFile) fd.append("beforeAttachment", beforeFile);
//         if (afterFile) fd.append("afterAttachment", afterFile);
//       } else {
//         fd.append("content", content.trim());
//         if (attachment) fd.append("attachment", attachment);
//       }

//       const d = await api.createPost(fd);
//       onPostCreated?.(d.post);
//       onClose();
//       if (location.pathname !== "/community") navigate("/community");
//     } catch (err) {
//       setError(err.error || "Failed to create post");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetAndClose = () => {
//     setContent("");
//     setPostType("default");
//     setAttachment(null);
//     setPreview(null);
//     setBeforeContent("");
//     setAfterContent("");
//     setBeforeFile(null);
//     setBeforePreview(null);
//     setAfterFile(null);
//     setAfterPreview(null);
//     setError("");
//     onClose();
//   };

//   const selectedLabel = POST_TYPES.find((t) => t.value === postType)?.label || "Default";
//   const isTestimony = postType === "testimony";

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
//       <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={resetAndClose} />

//       {/* Modal - Responsive */}
//       <div className="relative bg-white rounded-xl sm:rounded-3xl w-full max-w-[1000px] h-auto max-h-[90vh] sm:max-h-[650.67px]  sm:h-[621.67px] flex flex-col shadow-2xl overflow-hidden">

//         {/* Header */}
//         <div className="flex items-center justify-center px-4 sm:px-6 pt-4 sm:pt-6 pb-2 flex-shrink-0 relative border-b border-gray-100">
//           <h2 className="text-[20px] sm:text-[24.87px] font-semibold text-[#1F3A60] font-body tracking-wide">
//             New Post
//           </h2>
//           <button
//             onClick={resetAndClose}
//             className="absolute right-4 sm:right-6 w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full transition-colors"
//           >
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2.5" strokeLinecap="round">
//               <line x1="18" y1="6" x2="6" y2="18" />
//               <line x1="6" y1="6" x2="18" y2="18" />
//             </svg>
//           </button>
//         </div>

//         {/* Scrollable Body */}
//         <div className="overflow-y-auto flex-1 px-4 sm:px-8 py-4 sm:py-5">
//           {/* User row */}
//           <div className="flex flex-wrap items-center gap-3 sm:gap-6 mb-4">
//             {/* Profile Picture */}
//             <Avatar 
//               src={avSrc(user?.avatar)} 
//               alt={user?.name} 
//               size={50}
//               className="flex-shrink-0 rounded-full object-cover"
//               style={{ width: "50px", height: "50px" }}
//             />

//             <div className="flex-1">
//               <p className="text-[18px] sm:text-[21.31px] font-semibold text-[#0F172A] font-body">
//                 {user?.name || "Brother Julian"}
//               </p>
//             </div>

//             {/* Type dropdown */}
//             <div className="relative flex-shrink-0">
//               <button
//                 type="button"
//                 onClick={() => setShowTypeMenu((p) => !p)}
//                 className="flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-200 rounded-lg text-[12px] sm:text-[13px] font-medium text-gray-600 font-body hover:bg-gray-50 transition-colors"
//               >
//                 {selectedLabel}
//                 <ChevronDown size={12} className="text-gray-400" />
//               </button>
//               {showTypeMenu && (
//                 <div className="absolute right-0 top-full mt-1.5 bg-white border border-gray-100 rounded-xl shadow-lg z-10 overflow-hidden min-w-[120px] sm:min-w-[140px]">
//                   {POST_TYPES.map((t) => (
//                     <button
//                       key={t.value}
//                       onClick={() => handleTypeSelect(t.value)}
//                       className={`w-full text-left px-3 sm:px-4 py-2 sm:py-2.5 text-[12px] sm:text-[13px] font-body hover:bg-gray-50 transition-colors
//                         ${postType === t.value ? "text-primary font-semibold" : "text-gray-700"}`}
//                     >
//                       {t.label}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {error && (
//             <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-600 font-body">
//               {error}
//             </div>
//           )}

//           {/* DEFAULT MODE */}
//           {!isTestimony && (
//             <>
//               <textarea
//                 value={content}
//                 onChange={(e) => setContent(e.target.value)}
//                 placeholder="What's on your mind?"
//                 rows={3}
//                 className="w-full resize-none outline-none text-[20px] sm:text-[26.64px] text-gray-700
//                   placeholder:text-gray-400 font-body leading-[1.6] mb-4 sm:mb-5
//                   bg-transparent border-none focus:ring-0 p-0"
//               />
//               <div className="flex justify-center">
//                 <ImageUploadBox
//                   preview={preview}
//                   onFile={handleFileSelect}
//                   onRemove={() => { setAttachment(null); setPreview(null); }}
//                   inputRef={fileRef}
//                 />
//               </div>
//             </>
//           )}

//           {/* TESTIMONY MODE - Mobile responsive column layout */}
//           {isTestimony && (
//             <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
//               {/* Before Column */}
//               <div className="flex-1 flex flex-col gap-3">
//                 <p className="text-[22px] sm:text-[27px] font-semibold text-[#1F3A60] font-body">
//                   Before
//                 </p>

//                 <div className="bg-[#F3F4F6] rounded-xl sm:rounded-2xl p-3 sm:p-4">
//                   <textarea
//                     value={beforeContent}
//                     onChange={(e) => setBeforeContent(e.target.value)}
//                     placeholder="What's on your mind?"
//                     rows={2}
//                     className="
//                       w-full
//                       bg-transparent
//                       rounded-xl
//                       resize-none
//                       outline-none
//                       text-[18px] sm:text-[23.93px]
//                       text-gray-700
//                       placeholder:text-gray-400
//                       font-body
//                       leading-[1.6]
//                       px-3 sm:px-4
//                       py-2 sm:py-3
//                       transition-all
//                     "
//                   />

//                   <div className="mt-3 sm:mt-4">
//                     <ImageUploadBox
//                       preview={beforePreview}
//                       onFile={handleBeforeFile}
//                       onRemove={() => {
//                         setBeforeFile(null);
//                         setBeforePreview(null);
//                       }}
//                       inputRef={beforeRef}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* After Column */}
//               <div className="flex-1 flex flex-col gap-3">
//                 <p className="text-[22px] sm:text-[27px] font-semibold text-[#1F3A60] font-body">
//                   After
//                 </p>

//                 <div className="bg-[#F3F4F6] rounded-xl sm:rounded-2xl p-3 sm:p-4">
//                   <textarea
//                     value={afterContent}
//                     onChange={(e) => setAfterContent(e.target.value)}
//                     placeholder="What's on your mind?"
//                     rows={2}
//                     className="
//                       w-full
//                       bg-transparent
//                       rounded-xl
//                       resize-none
//                       outline-none
//                       text-[18px] sm:text-[23.93px]
//                       text-gray-700
//                       placeholder:text-gray-400
//                       font-body
//                       leading-[1.6]
//                       px-3 sm:px-4
//                       py-2 sm:py-3
//                       transition-all
//                     "
//                   />

//                   <div className="mt-3 sm:mt-4">
//                     <ImageUploadBox
//                       preview={afterPreview}
//                       onFile={handleAfterFile}
//                       onRemove={() => {
//                         setAfterFile(null);
//                         setAfterPreview(null);
//                       }}
//                       inputRef={afterRef}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="flex justify-end gap-3 px-4 sm:px-8 py-3 sm:py-4 flex-shrink-0 border-t border-gray-100">
//           <button
//             onClick={handleSubmit}
//             disabled={loading}
//             className="flex items-center gap-2 px-5 sm:px-6 py-2 sm:py-2.5 bg-[#FEDC5A] text-gray-900 rounded-lg font-semibold text-[14px] sm:text-[16px] font-body hover:brightness-110 transition-all disabled:opacity-50"
//           >
//             <Icon name="edit" size={14} />
//             {loading ? "Posting..." : "Post"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreatePostModal;


import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/api";
import Avatar from "../common/Avatar";
import Icon from "../common/Icon";
import { ChevronDown } from "lucide-react";
import FileAttachment from "../../components/FileAttachment"; // ← Import the new component
import { toast } from "react-toastify";

const API_ROOT = (
  process.env.REACT_APP_API_URL || "http://localhost:5000/api"
).replace("/api", "");

const avSrc = (p) =>
  !p
    ? "/assets/images/avatar-brother-julian.png"
    : p.startsWith("/uploads")
      ? `${API_ROOT}${p}`
      : p;

const POST_TYPES = [
  { value: "default", label: "Default" },
  { value: "testimony", label: "Testimony" },
];

const CreatePostModal = ({ isOpen, onClose, onPostCreated }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const [postType, setPostType] = useState("default");
  const [showTypeMenu, setShowTypeMenu] = useState(false);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Default mode
  const [attachment, setAttachment] = useState(null);

  // Testimony mode
  const [beforeFile, setBeforeFile] = useState(null);
  const [afterFile, setAfterFile] = useState(null);
  const [beforeContent, setBeforeContent] = useState("");
  const [afterContent, setAfterContent] = useState("");

  const handleTypeSelect = (val) => {
    setPostType(val);
    setShowTypeMenu(false);
  };

  const handleSubmit = async () => {
    const isTestimony = postType === "testimony";

    if (isTestimony) {
      if (!beforeContent.trim() && !afterContent.trim()) {
        setError("Write something in Before or After...");
        return;
      }
    } else {
      if (!content.trim()) {
        setError("Write something to share...");
        return;
      }
    }

    setError("");
    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("type", postType);

      if (isTestimony) {
        fd.append("before_text", beforeContent.trim());
        fd.append("after_text", afterContent.trim());
        if (beforeFile) fd.append("before_media", beforeFile);
        if (afterFile) fd.append("after_media", afterFile);
      } else {
        fd.append("content", content.trim());
        if (attachment) fd.append("attachment", attachment);
      }

      const result = await api.createPost(fd);
      if (!result.flagged) {
        onPostCreated?.(result.post);
        toast.success("Post Created Successfully");
      }
      else{
        toast.success("Post Created. Need to review");
      }
      onClose();
      if (location.pathname !== "/community") navigate("/community");
    } catch (err) {
      setError(err.error || "Failed to create post");
    } finally {
      setLoading(false);
    }
  };

  const resetAndClose = () => {
    setContent("");
    setPostType("default");
    setAttachment(null);
    setBeforeContent("");
    setAfterContent("");
    setBeforeFile(null);
    setAfterFile(null);
    setError("");
    onClose();
  };

  const selectedLabel = POST_TYPES.find((t) => t.value === postType)?.label || "Default";
  const isTestimony = postType === "testimony";

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={resetAndClose} />

      <div className="relative bg-white rounded-xl sm:rounded-3xl w-full max-w-[1000px] h-auto max-h-[90vh] sm:max-h-[650.67px] sm:h-[621.67px] flex flex-col shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-center px-4 sm:px-6 pt-4 sm:pt-6 pb-2 flex-shrink-0 relative border-b border-gray-100">
          <h2 className="text-[20px] sm:text-[24.87px] font-semibold text-[#1F3A60] font-body tracking-wide">
            New Post
          </h2>
          <button
            onClick={resetAndClose}
            className="absolute right-4 sm:right-6 w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="overflow-y-auto flex-1 px-4 sm:px-8 py-4 sm:py-5">
          {/* User row */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-6 mb-4">
            <Avatar
              src={avSrc(user?.avatar)}
              alt={user?.name}
              size={50}
              className="flex-shrink-0 rounded-full object-cover"
              style={{ width: "50px", height: "50px" }}
            />

            <div className="flex-1">
              <p className="text-[18px] sm:text-[21.31px] font-semibold text-[#0F172A] font-body">
                {user?.name || "Brother Julian"}
              </p>
            </div>

            {/* Type dropdown */}
            <div className="relative flex-shrink-0">
              <button
                type="button"
                onClick={() => setShowTypeMenu((p) => !p)}
                className="flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-200 rounded-lg text-[12px] sm:text-[13px] font-medium text-gray-600 font-body hover:bg-gray-50 transition-colors"
              >
                {selectedLabel}
                <ChevronDown size={12} className="text-gray-400" />
              </button>

              {showTypeMenu && (
                <div className="absolute right-0 top-full mt-1.5 bg-white border border-gray-100 rounded-xl shadow-lg z-10 overflow-hidden min-w-[120px] sm:min-w-[140px]">
                  {POST_TYPES.map((t) => (
                    <button
                      key={t.value}
                      onClick={() => handleTypeSelect(t.value)}
                      className={`w-full text-left px-3 sm:px-4 py-2 sm:py-2.5 text-[12px] sm:text-[13px] font-body hover:bg-gray-50 transition-colors
                        ${postType === t.value ? "text-primary font-semibold" : "text-gray-700"}`}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-600 font-body">
              {error}
            </div>
          )}

          {/* DEFAULT MODE */}
          {!isTestimony && (
            <>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="What's on your mind?"
                rows={3}
                className="w-full resize-none outline-none text-[20px] sm:text-[26.64px] text-gray-700
                  placeholder:text-gray-400 font-body leading-[1.6] mb-4 sm:mb-5
                  bg-transparent border-none focus:ring-0 p-0"
              />

              <div>
                <FileAttachment
                  accept="image/*,video/*"
                  maxSizeMB={10}
                  onChange={setAttachment}
                // className="w-full max-w-[520px]"
                />
              </div>
            </>
          )}

          {/* TESTIMONY MODE */}
          {isTestimony && (
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              {/* Before Column */}
              <div className="flex-1 flex flex-col gap-3">
                <p className="text-[22px] sm:text-[27px] font-semibold text-[#1F3A60] font-body">
                  Before
                </p>
                <div className="bg-[#F3F4F6] rounded-xl sm:rounded-2xl p-3 sm:p-4">
                  <textarea
                    value={beforeContent}
                    onChange={(e) => setBeforeContent(e.target.value)}
                    placeholder="What's on your mind?"
                    rows={2}
                    className="w-full bg-transparent rounded-xl resize-none outline-none text-[18px] sm:text-[23.93px] text-gray-700 placeholder:text-gray-400 font-body leading-[1.6] px-3 sm:px-4 py-2 sm:py-3 transition-all"
                  />
                  <div>
                    <FileAttachment
                      accept="image/*,video/*"
                      maxSizeMB={10}
                      onChange={setBeforeFile}
                    />
                  </div>
                </div>
              </div>

              {/* After Column */}
              <div className="flex-1 flex flex-col gap-3">
                <p className="text-[22px] sm:text-[27px] font-semibold text-[#1F3A60] font-body">
                  After
                </p>
                <div className="bg-[#F3F4F6] rounded-xl sm:rounded-2xl p-3 sm:p-4">
                  <textarea
                    value={afterContent}
                    onChange={(e) => setAfterContent(e.target.value)}
                    placeholder="What's on your mind?"
                    rows={2}
                    className="w-full bg-transparent rounded-xl resize-none outline-none text-[18px] sm:text-[23.93px] text-gray-700 placeholder:text-gray-400 font-body leading-[1.6] px-3 sm:px-4 py-2 sm:py-3 transition-all"
                  />
                  <div>
                    <FileAttachment
                      accept="image/*,video/*"
                      maxSizeMB={10}
                      onChange={setAfterFile}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-4 sm:px-8 py-3 sm:py-4 flex-shrink-0 border-t border-gray-100">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="flex items-center gap-2 px-5 sm:px-6 py-2 sm:py-2.5 bg-[#FEDC5A] text-gray-900 rounded-lg font-semibold text-[14px] sm:text-[16px] font-body hover:brightness-110 transition-all disabled:opacity-50"
          >
            <Icon name="edit" size={14} />
            {loading ? "Posting..." : "Post"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal;